<template>
	<div class="container-modal form-modal">
		<div class="container-holder">
			<div class="header-modal">
				<!-- <div class="icon"><icon-cart /></div> -->
				<div class="title"><span class="yellow" v-html="packagesList[0].name"></span></div>
				<div class="description" v-html="packagesList[0].fe_description"></div>
			</div>

			<div class="course-price" v-if="loaded">
				<div class="old-price" v-if="packagesList[0].compare_at_price_euro != null">&euro;{{ packagesList[0].compare_at_price_euro }}</div>
				<div class="new-price">&euro;{{ (packagesList[0].price_in_euro / 1.19).toFixed(0) | numeral('0,0') }}<span>+TVA</span></div>
			</div>

			<div class="submit-form">
				<button class="button-submit" id="buttonSubmitStep2" @click="goNextStep">
					<div class="loader-spin" v-if="loadingSubmit"></div>
					<div class="text" v-else>{{$t('register.button-action-2')}}</div>
				</button>
			</div>

			<div class="submodal-container" v-if="subModalShow">
				<div class="overlay-submodal"></div>

				<div class="submodal-tbf active">
					<div class="container-content-modal">
						<div class="header-modal">
							<div class="title">{{ $t('register.step-2.confirm_subscription_title') }}</div>
							<div class="actions">
								<div class="btn-default-tbf close-btn" @click="closeModalCoupon"><icon-plus class="icon-close" /></div>
							</div>
						</div>
						<div class="summary">
							<div class="summary-box">
								{{ $t('register.step-2.confirm_subscription_summary', { package: packageActive.name, price: user.newPrices.find((el) => el.package_id == packageActive.id) ? user.newPrices.find((el) => el.package_id == packageActive.id).price + ' ' + packageActive.euro_prefix : packageActive.price_in_euro + ' ' + packageActive.euro_prefix}) }}
							</div>

							<div class="submit-form">
								<button class="button-tbf-blue button-submit btn-confirm-modal" @click="goNextStep">
									<div class="loader"></div>
									<div class="text">{{ $t('register.step-2.confirm') }}</div>
								</button>
							</div>
						</div>
					</div>


				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import CloseIcon from '../Icons/Close'
	import IconPlus from "../Icons/Plus"
	import IconInfo from "../Icons/Info"
	import IconFolder from "../Icons/Folder"
	import IconArrow from "../Icons/Arrow"
	import IconPeople from "../Icons/People"
	import IconCircleCheck from "../Icons/CircleCheck"
	import InformationIcon from '../Icons/Information'
	import IconIndividual from '../Icons/Individual'
	import IconOffice from '../Icons/Office'
	import IconCnp from '../Icons/Cnp'
	import IconBuilding	from '../Icons/Building'
	import IconCui	from '../Icons/Cui'
	import UserSettingsIcon from '../Icons/UserSettings';
	import SettingsGoalIcon from '../Icons/SettingsGoal';
	import IconObjectivesList from '../Icons/ObjectivesList'
	import PasswordIcon from '../Icons/Password';
	import IconCart from '../Icons/Cart'

	export default {
		data(){
			return {
				activeTooltip: '',
				packageActive: {},
				packagesList: {},
				cardErrors: {},
				subModalShow: false,
				loaded: false,
				errorSelectPlan: false,
				loadingSubmit: false
			}
		},
		props:{
			user: Object
		},
		components: {
			CloseIcon,
			IconPlus,
			IconInfo,
			IconFolder,
			IconArrow,
			IconPeople,
			IconCircleCheck,
			InformationIcon,
			IconIndividual,
			IconOffice,
			IconBuilding,
			IconCnp,
			IconCui,
			UserSettingsIcon,
			SettingsGoalIcon,
			IconObjectivesList,
			PasswordIcon,
			IconCart
		},
		async mounted() {
			await this.getPackages()
		},
		methods: {
			async getPackages(){
				await axios.get('packages').then(({data}) => {
					this.packagesList = data.reverse();
					if(this.$route.query.reducere){
						this.packageActive = this.packagesList.find(el => el.token == this.$route.query.reducere)
						if(this.packageActive){
							this.user.packageActive = this.packageActive
						}else{
							this.packageActive = this.packagesList.find(el => el.token == "c9e2204e-82ef-11ee-b962-0242ac120002")
							this.user.packageActive = this.packageActive	
						}
					}else{
						// default merge pe Curs de management pret intreg
						this.packageActive = this.packagesList.find(el => el.token == "c9e2204e-82ef-11ee-b962-0242ac120002")
						this.user.packageActive = this.packageActive
					}
					this.packagesList = [this.packageActive];
					this.loaded = true;
					this.logoAnim();
				});
			},
			openConfirmation(){
				this.errorSelectPlan = false

				if(this.packageActive.id){
					this.subModalShow = true;
				}else{
					this.errorSelectPlan = true
				}
			},
			goNextStep(e){
				var btnSubmit = document.getElementById('buttonSubmitStep2');
				btnSubmit.disabled = true;
				this.loadingSubmit = true;
				
				setTimeout(()=>{
					this.$emit("next_step", {user: this.user, next_step: 21});
				}, 500)
			},

			closeModal(){
				this.$router.push("/login");
			},
			closeModalCoupon() {
				this.subModalShow = false;
			},
			selectPlan(packageItem){
				this.errorSelectPlan = false
				this.packageActive = packageItem;
				this.user.packageActive = packageItem;
			},
			displayModal(){
				this.subModalShow = true;
			},
			handleAnimationLogo(anim){
				this.anim_logo = anim;
				this.anim_logo.setSpeed(1);
			},
			logoAnim(){
				// if(this.finished && !this.bird_noti){
				// 	this.finished = false;
				// 	this.anim_logo.play();
				// 	setTimeout(() => {
				// 		this.anim_logo.stop();
				// 		this.finished = true;
				// 	}, 5000);
				// }
			}
		}
	}
</script>